'use client';

import clsx from 'clsx';
import type { ErrorProps } from 'mdx-transformer';
import { useRouter } from 'next-nprogress-bar';
import { FOCUS_RING_BRAND_SHADOW_SM } from 'ui';

export function MDXError({ title, description, cta }: ErrorProps) {
  const router = useRouter();
  return (
    <span className="relative my-5 flex gap-2 rounded-xl border border-primary p-4 pl-[52px]">
      <span className="absolute left-[7px] top-[7px] block h-fit rounded-full border-2 border-error-100 p-[3px]">
        <span className="block rounded-full border-2 border-error-400 p-0.5">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#error_msg)">
              <path
                d="M10.0001 6.66663V9.99996M10.0001 13.3333H10.0084M18.3334 9.99996C18.3334 14.6023 14.6025 18.3333 10.0001 18.3333C5.39771 18.3333 1.66675 14.6023 1.66675 9.99996C1.66675 5.39759 5.39771 1.66663 10.0001 1.66663C14.6025 1.66663 18.3334 5.39759 18.3334 9.99996Z"
                stroke="#D92D20"
                strokeWidth="1.66667"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <defs>
              <clipPath id="error_msg">
                <rect width="20" height="20" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </span>
      </span>
      <span className="block">
        <span className="not-prose mb-1 block text-base font-medium leading-6 text-secondary">
          {title}
        </span>
        <span className="not-prose block text-sm leading-5 text-tertiary">
          {description}
        </span>
        {cta?.label && (
          <span className="mt-3 block">
            <button
              type="button"
              className={clsx(
                'rounded-sm text-sm font-semibold text-brand-secondary transition hover:text-brand-primary',
                FOCUS_RING_BRAND_SHADOW_SM,
              )}
              onClick={() => {
                router.push(cta.href);
              }}
            >
              {cta.label}
            </button>
          </span>
        )}
      </span>
    </span>
  );
}
